import { createFileRoute } from "@tanstack/react-router";
import { MainSidebar } from "../../components/sidebars/MainSidebar";
import { ApksPage } from "./-ApksPage";

function ApksPageWithSidebar() {
  return (
    <div className="flex h-screen">
      <MainSidebar />
      <div className="flex-1 overflow-auto">
        <ApksPage />
      </div>
    </div>
  );
}

export const Route = createFileRoute("/admin/apks")({
  component: ApksPageWithSidebar,
});
